import { render, staticRenderFns } from "./credit-plan-management.vue?vue&type=template&id=6f95b007"
import script from "./credit-plan-management.vue?vue&type=script&lang=js"
export * from "./credit-plan-management.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports